/*!
 * hoverIntent v1.10.1 // 2019.10.05 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),$.isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=$.isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});


/*
    A simple jQuery modal (http://github.com/kylefox/jquery-modal)
    Version 0.9.1
*/
!function(o){"object"==typeof module&&"object"==typeof module.exports?o(require("jquery"),window,document):o(jQuery,window,document)}(function(o,t,i,e){var s=[],l=function(){return s.length?s[s.length-1]:null},n=function(){var o,t=!1;for(o=s.length-1;o>=0;o--)s[o].$blocker&&(s[o].$blocker.toggleClass("current",!t).toggleClass("behind",t),t=!0)};o.modal=function(t,i){var e,n;if(this.$body=o("body"),this.options=o.extend({},o.modal.defaults,i),this.options.doFade=!isNaN(parseInt(this.options.fadeDuration,10)),this.$blocker=null,this.options.closeExisting)for(;o.modal.isActive();)o.modal.close();if(s.push(this),t.is("a"))if(n=t.attr("href"),this.anchor=t,/^#/.test(n)){if(this.$elm=o(n),1!==this.$elm.length)return null;this.$body.append(this.$elm),this.open()}else this.$elm=o("<div>"),this.$body.append(this.$elm),e=function(o,t){t.elm.remove()},this.showSpinner(),t.trigger(o.modal.AJAX_SEND),o.get(n).done(function(i){if(o.modal.isActive()){t.trigger(o.modal.AJAX_SUCCESS);var s=l();s.$elm.empty().append(i).on(o.modal.CLOSE,e),s.hideSpinner(),s.open(),t.trigger(o.modal.AJAX_COMPLETE)}}).fail(function(){t.trigger(o.modal.AJAX_FAIL);var i=l();i.hideSpinner(),s.pop(),t.trigger(o.modal.AJAX_COMPLETE)});else this.$elm=t,this.anchor=t,this.$body.append(this.$elm),this.open()},o.modal.prototype={constructor:o.modal,open:function(){var t=this;this.block(),this.anchor.blur(),this.options.doFade?setTimeout(function(){t.show()},this.options.fadeDuration*this.options.fadeDelay):this.show(),o(i).off("keydown.modal").on("keydown.modal",function(o){var t=l();27===o.which&&t.options.escapeClose&&t.close()}),this.options.clickClose&&this.$blocker.click(function(t){t.target===this&&o.modal.close()})},close:function(){s.pop(),this.unblock(),this.hide(),o.modal.isActive()||o(i).off("keydown.modal")},block:function(){this.$elm.trigger(o.modal.BEFORE_BLOCK,[this._ctx()]),this.$body.css("overflow","hidden"),this.$blocker=o('<div class="'+this.options.blockerClass+' blocker current"></div>').appendTo(this.$body),n(),this.options.doFade&&this.$blocker.css("opacity",0).animate({opacity:1},this.options.fadeDuration),this.$elm.trigger(o.modal.BLOCK,[this._ctx()])},unblock:function(t){!t&&this.options.doFade?this.$blocker.fadeOut(this.options.fadeDuration,this.unblock.bind(this,!0)):(this.$blocker.children().appendTo(this.$body),this.$blocker.remove(),this.$blocker=null,n(),o.modal.isActive()||this.$body.css("overflow",""))},show:function(){this.$elm.trigger(o.modal.BEFORE_OPEN,[this._ctx()]),this.options.showClose&&(this.closeButton=o('<a href="#close-modal" rel="modal:close" class="close-modal '+this.options.closeClass+'">'+this.options.closeText+"</a>"),this.$elm.append(this.closeButton)),this.$elm.addClass(this.options.modalClass).appendTo(this.$blocker),this.options.doFade?this.$elm.css({opacity:0,display:"inline-block"}).animate({opacity:1},this.options.fadeDuration):this.$elm.css("display","inline-block"),this.$elm.trigger(o.modal.OPEN,[this._ctx()])},hide:function(){this.$elm.trigger(o.modal.BEFORE_CLOSE,[this._ctx()]),this.closeButton&&this.closeButton.remove();var t=this;this.options.doFade?this.$elm.fadeOut(this.options.fadeDuration,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}):this.$elm.hide(0,function(){t.$elm.trigger(o.modal.AFTER_CLOSE,[t._ctx()])}),this.$elm.trigger(o.modal.CLOSE,[this._ctx()])},showSpinner:function(){this.options.showSpinner&&(this.spinner=this.spinner||o('<div class="'+this.options.modalClass+'-spinner"></div>').append(this.options.spinnerHtml),this.$body.append(this.spinner),this.spinner.show())},hideSpinner:function(){this.spinner&&this.spinner.remove()},_ctx:function(){return{elm:this.$elm,$elm:this.$elm,$blocker:this.$blocker,options:this.options}}},o.modal.close=function(t){if(o.modal.isActive()){t&&t.preventDefault();var i=l();return i.close(),i.$elm}},o.modal.isActive=function(){return s.length>0},o.modal.getCurrent=l,o.modal.defaults={closeExisting:!0,escapeClose:!0,clickClose:!0,closeText:"Close",closeClass:"",modalClass:"modal",blockerClass:"jquery-modal",spinnerHtml:'<div class="rect1"></div><div class="rect2"></div><div class="rect3"></div><div class="rect4"></div>',showSpinner:!0,showClose:!0,fadeDuration:null,fadeDelay:1},o.modal.BEFORE_BLOCK="modal:before-block",o.modal.BLOCK="modal:block",o.modal.BEFORE_OPEN="modal:before-open",o.modal.OPEN="modal:open",o.modal.BEFORE_CLOSE="modal:before-close",o.modal.CLOSE="modal:close",o.modal.AFTER_CLOSE="modal:after-close",o.modal.AJAX_SEND="modal:ajax:send",o.modal.AJAX_SUCCESS="modal:ajax:success",o.modal.AJAX_FAIL="modal:ajax:fail",o.modal.AJAX_COMPLETE="modal:ajax:complete",o.fn.modal=function(t){return 1===this.length&&new o.modal(this,t),this},o(i).on("click.modal",'a[rel~="modal:close"]',o.modal.close),o(i).on("click.modal",'a[rel~="modal:open"]',function(t){t.preventDefault(),o(this).modal()})});

!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define("scrollMonitor",[],e):"object"==typeof exports?exports.scrollMonitor=e():t.scrollMonitor=e()}(this,function(){return function(t){function e(o){if(i[o])return i[o].exports;var s=i[o]={exports:{},id:o,loaded:!1};return t[o].call(s.exports,s,s.exports,e),s.loaded=!0,s.exports}var i={};return e.m=t,e.c=i,e.p="",e(0)}([function(t,e,i){"use strict";var o=i(1),s=o.isInBrowser,n=i(2),r=new n(s?document.body:null);r.setStateFromDOM(null),r.listenToDOM(),s&&(window.scrollMonitor=r),t.exports=r},function(t,e){"use strict";e.VISIBILITYCHANGE="visibilityChange",e.ENTERVIEWPORT="enterViewport",e.FULLYENTERVIEWPORT="fullyEnterViewport",e.EXITVIEWPORT="exitViewport",e.PARTIALLYEXITVIEWPORT="partiallyExitViewport",e.LOCATIONCHANGE="locationChange",e.STATECHANGE="stateChange",e.eventTypes=[e.VISIBILITYCHANGE,e.ENTERVIEWPORT,e.FULLYENTERVIEWPORT,e.EXITVIEWPORT,e.PARTIALLYEXITVIEWPORT,e.LOCATIONCHANGE,e.STATECHANGE],e.isOnServer="undefined"==typeof window,e.isInBrowser=!e.isOnServer,e.defaultOffsets={top:0,bottom:0}},function(t,e,i){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t){return c?0:t===document.body?window.innerHeight||document.documentElement.clientHeight:t.clientHeight}function n(t){return c?0:t===document.body?Math.max(document.body.scrollHeight,document.documentElement.scrollHeight,document.body.offsetHeight,document.documentElement.offsetHeight,document.documentElement.clientHeight):t.scrollHeight}function r(t){return c?0:t===document.body?window.pageYOffset||document.documentElement&&document.documentElement.scrollTop||document.body.scrollTop:t.scrollTop}var h=i(1),c=h.isOnServer,a=h.isInBrowser,l=h.eventTypes,p=i(3),u=!1;if(a)try{var w=Object.defineProperty({},"passive",{get:function(){u=!0}});window.addEventListener("test",null,w)}catch(t){}var d=!!u&&{capture:!1,passive:!0},f=function(){function t(e,i){function h(){if(a.viewportTop=r(e),a.viewportBottom=a.viewportTop+a.viewportHeight,a.documentHeight=n(e),a.documentHeight!==p){for(u=a.watchers.length;u--;)a.watchers[u].recalculateLocation();p=a.documentHeight}}function c(){for(w=a.watchers.length;w--;)a.watchers[w].update();for(w=a.watchers.length;w--;)a.watchers[w].triggerCallbacks()}o(this,t);var a=this;this.item=e,this.watchers=[],this.viewportTop=null,this.viewportBottom=null,this.documentHeight=n(e),this.viewportHeight=s(e),this.DOMListener=function(){t.prototype.DOMListener.apply(a,arguments)},this.eventTypes=l,i&&(this.containerWatcher=i.create(e));var p,u,w;this.update=function(){h(),c()},this.recalculateLocations=function(){this.documentHeight=0,this.update()}}return t.prototype.listenToDOM=function(){a&&(window.addEventListener?(this.item===document.body?window.addEventListener("scroll",this.DOMListener,d):this.item.addEventListener("scroll",this.DOMListener,d),window.addEventListener("resize",this.DOMListener)):(this.item===document.body?window.attachEvent("onscroll",this.DOMListener):this.item.attachEvent("onscroll",this.DOMListener),window.attachEvent("onresize",this.DOMListener)),this.destroy=function(){window.addEventListener?(this.item===document.body?(window.removeEventListener("scroll",this.DOMListener,d),this.containerWatcher.destroy()):this.item.removeEventListener("scroll",this.DOMListener,d),window.removeEventListener("resize",this.DOMListener)):(this.item===document.body?(window.detachEvent("onscroll",this.DOMListener),this.containerWatcher.destroy()):this.item.detachEvent("onscroll",this.DOMListener),window.detachEvent("onresize",this.DOMListener))})},t.prototype.destroy=function(){},t.prototype.DOMListener=function(t){this.setStateFromDOM(t)},t.prototype.setStateFromDOM=function(t){var e=r(this.item),i=s(this.item),o=n(this.item);this.setState(e,i,o,t)},t.prototype.setState=function(t,e,i,o){var s=e!==this.viewportHeight||i!==this.contentHeight;if(this.latestEvent=o,this.viewportTop=t,this.viewportHeight=e,this.viewportBottom=t+e,this.contentHeight=i,s)for(var n=this.watchers.length;n--;)this.watchers[n].recalculateLocation();this.updateAndTriggerWatchers(o)},t.prototype.updateAndTriggerWatchers=function(t){for(var e=this.watchers.length;e--;)this.watchers[e].update();for(e=this.watchers.length;e--;)this.watchers[e].triggerCallbacks(t)},t.prototype.createCustomContainer=function(){return new t},t.prototype.createContainer=function(e){"string"==typeof e?e=document.querySelector(e):e&&e.length>0&&(e=e[0]);var i=new t(e,this);return i.setStateFromDOM(),i.listenToDOM(),i},t.prototype.create=function(t,e){"string"==typeof t?t=document.querySelector(t):t&&t.length>0&&(t=t[0]);var i=new p(this,t,e);return this.watchers.push(i),i},t.prototype.beget=function(t,e){return this.create(t,e)},t}();t.exports=f},function(t,e,i){"use strict";function o(t,e,i){function o(t,e){if(0!==t.length)for(E=t.length;E--;)y=t[E],y.callback.call(s,e,s),y.isOne&&t.splice(E,1)}var s=this;this.watchItem=e,this.container=t,i?i===+i?this.offsets={top:i,bottom:i}:this.offsets={top:i.top||w.top,bottom:i.bottom||w.bottom}:this.offsets=w,this.callbacks={};for(var d=0,f=u.length;d<f;d++)s.callbacks[u[d]]=[];this.locked=!1;var m,v,b,I,E,y;this.triggerCallbacks=function(t){switch(this.isInViewport&&!m&&o(this.callbacks[r],t),this.isFullyInViewport&&!v&&o(this.callbacks[h],t),this.isAboveViewport!==b&&this.isBelowViewport!==I&&(o(this.callbacks[n],t),v||this.isFullyInViewport||(o(this.callbacks[h],t),o(this.callbacks[a],t)),m||this.isInViewport||(o(this.callbacks[r],t),o(this.callbacks[c],t))),!this.isFullyInViewport&&v&&o(this.callbacks[a],t),!this.isInViewport&&m&&o(this.callbacks[c],t),this.isInViewport!==m&&o(this.callbacks[n],t),!0){case m!==this.isInViewport:case v!==this.isFullyInViewport:case b!==this.isAboveViewport:case I!==this.isBelowViewport:o(this.callbacks[p],t)}m=this.isInViewport,v=this.isFullyInViewport,b=this.isAboveViewport,I=this.isBelowViewport},this.recalculateLocation=function(){if(!this.locked){var t=this.top,e=this.bottom;if(this.watchItem.nodeName){var i=this.watchItem.style.display;"none"===i&&(this.watchItem.style.display="");for(var s=0,n=this.container;n.containerWatcher;)s+=n.containerWatcher.top-n.containerWatcher.container.viewportTop,n=n.containerWatcher.container;var r=this.watchItem.getBoundingClientRect();this.top=r.top+this.container.viewportTop-s,this.bottom=r.bottom+this.container.viewportTop-s,"none"===i&&(this.watchItem.style.display=i)}else this.watchItem===+this.watchItem?this.watchItem>0?this.top=this.bottom=this.watchItem:this.top=this.bottom=this.container.documentHeight-this.watchItem:(this.top=this.watchItem.top,this.bottom=this.watchItem.bottom);this.top-=this.offsets.top,this.bottom+=this.offsets.bottom,this.height=this.bottom-this.top,void 0===t&&void 0===e||this.top===t&&this.bottom===e||o(this.callbacks[l],null)}},this.recalculateLocation(),this.update(),m=this.isInViewport,v=this.isFullyInViewport,b=this.isAboveViewport,I=this.isBelowViewport}var s=i(1),n=s.VISIBILITYCHANGE,r=s.ENTERVIEWPORT,h=s.FULLYENTERVIEWPORT,c=s.EXITVIEWPORT,a=s.PARTIALLYEXITVIEWPORT,l=s.LOCATIONCHANGE,p=s.STATECHANGE,u=s.eventTypes,w=s.defaultOffsets;o.prototype={on:function(t,e,i){switch(!0){case t===n&&!this.isInViewport&&this.isAboveViewport:case t===r&&this.isInViewport:case t===h&&this.isFullyInViewport:case t===c&&this.isAboveViewport&&!this.isInViewport:case t===a&&this.isInViewport&&this.isAboveViewport:if(e.call(this,this.container.latestEvent,this),i)return}if(!this.callbacks[t])throw new Error("Tried to add a scroll monitor listener of type "+t+". Your options are: "+u.join(", "));this.callbacks[t].push({callback:e,isOne:i||!1})},off:function(t,e){if(!this.callbacks[t])throw new Error("Tried to remove a scroll monitor listener of type "+t+". Your options are: "+u.join(", "));for(var i,o=0;i=this.callbacks[t][o];o++)if(i.callback===e){this.callbacks[t].splice(o,1);break}},one:function(t,e){this.on(t,e,!0)},recalculateSize:function(){this.height=this.watchItem.offsetHeight+this.offsets.top+this.offsets.bottom,this.bottom=this.top+this.height},update:function(){this.isAboveViewport=this.top<this.container.viewportTop,this.isBelowViewport=this.bottom>this.container.viewportBottom,this.isInViewport=this.top<this.container.viewportBottom&&this.bottom>this.container.viewportTop,this.isFullyInViewport=this.top>=this.container.viewportTop&&this.bottom<=this.container.viewportBottom||this.isAboveViewport&&this.isBelowViewport},destroy:function(){var t=this.container.watchers.indexOf(this),e=this;this.container.watchers.splice(t,1);for(var i=0,o=u.length;i<o;i++)e.callbacks[u[i]].length=0},lock:function(){this.locked=!0},unlock:function(){this.locked=!1}};for(var d=function(t){return function(e,i){this.on.call(this,t,e,i)}},f=0,m=u.length;f<m;f++){var v=u[f];o.prototype[v]=d(v)}t.exports=o}])});
//# sourceMappingURL=scrollMonitor.js.map


// body-scrol-lock
!function(e,t){if("function"==typeof define&&define.amd)define(["exports"],t);else if("undefined"!=typeof exports)t(exports);else{var o={};t(o),e.bodyScrollLock=o}}(this,function(e){"use strict";function t(e){if(Array.isArray(e)){for(var t=0,o=Array(e.length);t<e.length;t++)o[t]=e[t];return o}return Array.from(e)}Object.defineProperty(e,"__esModule",{value:!0});var o=!1;if("undefined"!=typeof window){var n={get passive(){o=!0}};window.addEventListener("testPassive",null,n),window.removeEventListener("testPassive",null,n)}function i(e){return c.some(function(t){return!(!t.options.allowTouchMove||!t.options.allowTouchMove(e))})}function r(e){var t=e||window.event;return!!i(t.target)||1<t.touches.length||(t.preventDefault&&t.preventDefault(),!1)}function l(){setTimeout(function(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)})}var d="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;e.disableBodyScroll=function(e,n){if(d){if(!e)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(e&&!c.some(function(t){return t.targetElement===e})){var l={targetElement:e,options:n||{}};c=[].concat(t(c),[l]),e.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},e.ontouchmove=function(t){var o,n,l,d;1===t.targetTouches.length&&(n=e,d=(o=t).targetTouches[0].clientY-u,i(o.target)||(n&&0===n.scrollTop&&0<d||(l=n)&&l.scrollHeight-l.scrollTop<=l.clientHeight&&d<0?r(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",r,o?{passive:!1}:void 0),a=!0)}}else{m=n,setTimeout(function(){if(void 0===v){var e=!!m&&!0===m.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;e&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")});var f={targetElement:e,options:n||{}};c=[].concat(t(c),[f])}var m},e.clearAllBodyScrollLocks=function(){d?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",r,o?{passive:!1}:void 0),a=!1),c=[],u=-1):(l(),c=[])},e.enableBodyScroll=function(e){if(d){if(!e)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");e.ontouchstart=null,e.ontouchmove=null,c=c.filter(function(t){return t.targetElement!==e}),a&&0===c.length&&(document.removeEventListener("touchmove",r,o?{passive:!1}:void 0),a=!1)}else(c=c.filter(function(t){return t.targetElement!==e})).length||l()}});

/*!
 * imagesLoaded PACKAGED v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(e,t){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",t):"object"==typeof module&&module.exports?module.exports=t():e.EvEmitter=t()}("undefined"!=typeof window?window:this,function(){function e(){}var t=e.prototype;return t.on=function(e,t){if(e&&t){var i=this._events=this._events||{},n=i[e]=i[e]||[];return n.indexOf(t)==-1&&n.push(t),this}},t.once=function(e,t){if(e&&t){this.on(e,t);var i=this._onceEvents=this._onceEvents||{},n=i[e]=i[e]||{};return n[t]=!0,this}},t.off=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){var n=i.indexOf(t);return n!=-1&&i.splice(n,1),this}},t.emitEvent=function(e,t){var i=this._events&&this._events[e];if(i&&i.length){i=i.slice(0),t=t||[];for(var n=this._onceEvents&&this._onceEvents[e],o=0;o<i.length;o++){var r=i[o],s=n&&n[r];s&&(this.off(e,r),delete n[r]),r.apply(this,t)}return this}},t.allOff=function(){delete this._events,delete this._onceEvents},e}),function(e,t){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return t(e,i)}):"object"==typeof module&&module.exports?module.exports=t(e,require("ev-emitter")):e.imagesLoaded=t(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){function i(e,t){for(var i in t)e[i]=t[i];return e}function n(e){if(Array.isArray(e))return e;var t="object"==typeof e&&"number"==typeof e.length;return t?d.call(e):[e]}function o(e,t,r){if(!(this instanceof o))return new o(e,t,r);var s=e;return"string"==typeof e&&(s=document.querySelectorAll(e)),s?(this.elements=n(s),this.options=i({},this.options),"function"==typeof t?r=t:i(this.options,t),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(this.check.bind(this))):void a.error("Bad element for imagesLoaded "+(s||e))}function r(e){this.img=e}function s(e,t){this.url=e,this.element=t,this.img=new Image}var h=e.jQuery,a=e.console,d=Array.prototype.slice;o.prototype=Object.create(t.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(e){"IMG"==e.nodeName&&this.addImage(e),this.options.background===!0&&this.addElementBackgroundImages(e);var t=e.nodeType;if(t&&u[t]){for(var i=e.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=e.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var u={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(e){var t=getComputedStyle(e);if(t)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(t.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,e),n=i.exec(t.backgroundImage)}},o.prototype.addImage=function(e){var t=new r(e);this.images.push(t)},o.prototype.addBackground=function(e,t){var i=new s(e,t);this.images.push(i)},o.prototype.check=function(){function e(e,i,n){setTimeout(function(){t.progress(e,i,n)})}var t=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(t){t.once("progress",e),t.check()}):void this.complete()},o.prototype.progress=function(e,t,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!e.isLoaded,this.emitEvent("progress",[this,e,t]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,e),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,e,t)},o.prototype.complete=function(){var e=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(e,[this]),this.emitEvent("always",[this]),this.jqDeferred){var t=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[t](this)}},r.prototype=Object.create(t.prototype),r.prototype.check=function(){var e=this.getIsImageComplete();return e?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},r.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.img,t])},r.prototype.handleEvent=function(e){var t="on"+e.type;this[t]&&this[t](e)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var e=this.getIsImageComplete();e&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(e,t){this.isLoaded=e,this.emitEvent("progress",[this,this.element,t])},o.makeJQueryPlugin=function(t){t=t||e.jQuery,t&&(h=t,h.fn.imagesLoaded=function(e,t){var i=new o(this,e,t);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});


var frameIndex = 0;
var frames = $('.lookbook-wrapper .look');
var S = {}

$(document).ready(function() {
  console.log("document ready!!!")
  S.size = {}
  S.size.all = function() {
    S.size.windowW = $(window).outerWidth();
    S.size.windowH = $(window).outerHeight();
    S.size.header = $(".header-interior").outerHeight();

    S.isDesktop = false;
    S.isTablet = false;
    S.isMobile = false;
    S.isLandscape = window.matchMedia("(orientation: landscape)").matches;


    if (S.size.windowW > 1024 || S.isLandscape) {
      S.isDesktop = true;
    } else if (S.size.windowW > 767) {
      S.isTablet = true;
    } else {
      S.isMobile = true;
    }

    console.log("S.isDesktop : " +  S.isDesktop );


  }




  S.scroll = {}
  S.scroll.action = function() {
    var scroll = $(window).scrollTop(), $h = $(".header:not(.with-promo-bar)"), $scrolls = $(".scroll-down, .scroll-up"),
    limit = 80;

    if (scroll > limit) {
      $h.addClass("header--scrolled");
      $scrolls.addClass("header--scrolled");
    } else if (scroll <= limit) {
      $h.removeClass("header--scrolled");
      $scrolls.removeClass("header--scrolled");
    }

    if (scroll > 10) {
      console.log("scroll: " + scroll);
      $h.addClass("header--actually-scrolled");
    } else if (scroll <= 10) {
      console.log("scroll: " + scroll);
      $h.removeClass("header--actually-scrolled");
    }
  }

  S.scroll.lock = function() {
    bodyScrollLock.disableBodyScroll($("#page-container"), {
       allowTouchMove: el => {
         while (el && el !== document.body) {
           if (el.getAttribute("body-scroll-lock-ignore") !== null) {
             return true
           }
           el = el.parentNode
         }
       }
     })
  }

  S.scroll.unlock = function() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }


  S.list = {}
  S.list.pop = function() {
    var $pop = $(".newsletter-popup");
    var $form = $("#pop_newsletter");
    // console.log("pop length: " + $pop.length);
    if ($pop.length) {
      // console.log("--- list.cookie");
      var cookiename = 'fog_emailpop_cookie';
      var cookie1 = Cookies.get(cookiename);
      var skipCookie = false;
      // console.log("cookie: " + cookie1);
      if (!cookie1 || skipCookie == true) {
        //no cookie, so set cookie
        Cookies.set(cookiename, 'visited', {
          expires: parseInt($form.attr("data-cookie-expire")),
          path: '/'
        });

        setTimeout(function() {
          $pop.addClass("active").find(".x-sm-close").click(function(e) {
            $(".newsletter-popup").removeClass("active");
            setTimeout(function() {
              $(".newsletter-pop").remove();
            }, 400)
          });
        }, 1200)

      }

      KlaviyoSubscribe.attachToForms('#pop_newsletter', {
        hide_form_on_success: true,
        success_message: $("#pop_newsletter").attr("data-success-msg"),
        success: function ($form) {
       // `$form` is a jQuery wrapper around the form that was submitted. This makes it easy to get the email address or form fields.
         $form.addClass("submitted");
         setTimeout(function() {
           $(".newsletter-popup").find(".x-sm-close").trigger("click");
         }, 3000)

       }
      });
    }


  }




  S.lookbook = {}
  S.lookbook.init = function() {
    $(".layout-page-lookbook .lookbook").each(function() {
      $(this).find(".link-overlay").click(function(e) {
        e.preventDefault();
        var id = $(this).attr("data-id");
        S.lookbook.detail(id);
      })
    })

    var hash = window.location.hash;
    console.log("hash: " + hash);

    if (hash && hash != "" && $(".layout-page-lookbook .look"+hash).length) {
      console.log("found look? " + $(".layout-page-lookbook .look"+hash).length);
      $(".layout-page-lookbook .look"+hash+" .link-overlay").trigger("click");
    }
  }

  S.lookbook.detail = function(id) {
    var looks = '';
    var tot = $(".lookbook .look").length;
    $(".lookbook .look").each(function() {
      var no = $(this).index() + 1;
      var src = $(this).attr("data-src-full");
      var alt = $(this).find("img").attr("alt");
      var detail_id = $(this).attr("id") + "-detail";
      var pagi = '<span class="lookbook-pagi type-e">'+no+'/'+tot+'</span>';
      var caption = '', landscape = $(this).hasClass("landscape-true");
      if ($(this).find(".block-content").length) {
        caption = '<div class="block-content type-f">'+$(this).find(".block-content").html()+'</div>';
      }
      var btn = '<button class="clear-btn link-overlay zoom-btn" aria-label="Zoom"><span class="displace">Zoom</span></button>';
      if (id == $(this).attr("id")) {
        var look = `<div class="block-image"><img
                  class="picture__img"
                  src="`+src+`"
                  data-src="`+src+`"
                  data-zoom-src="`+src+`"
                  alt="`+alt+`"
                />`+btn+`</div>`;
      } else {
        var look = `<div class="block-image"><img
                  class="picture__img lazyload"
                  data-src="`+src+`"
                  data-zoom-src="`+src+`"
                  alt="`+alt+`"
                />`+btn+`</div>`;
      }
      look = '<div class="block-interior">'+look+caption+'</div>';
      looks = looks + '<div class="look-detail landscape-'+landscape+'" id="'+detail_id+'">'+look+pagi+'</div>';
    })

    var scroll_up = `<button class="clear-btn scroll-up-looks" aria-label="Back to Top">
    	<svg xmlns="http://www.w3.org/2000/svg" width="14.691" height="23.01" viewBox="0 0 14.691 23.01">
    	  <g id="Component_22_9" data-name="Component 22 – 9" transform="translate(0.36)">
    	    <g id="Group_26167" data-name="Group 26167" transform="translate(13.972) rotate(90)">
    	      <line id="Line_1234" data-name="Line 1234" x2="22.465" transform="translate(0 6.986)" fill="none" stroke="#000" stroke-width="1"/>
    	      <g id="Group_25960" data-name="Group 25960" transform="translate(15.421)">
    	        <line id="Line_1235" data-name="Line 1235" x2="7.242" y2="7.01" fill="none" stroke="#000" stroke-width="1"/>
    	        <line id="Line_1236" data-name="Line 1236" y1="6.962" x2="7.242" transform="translate(0 7.01)" fill="none" stroke="#000" stroke-width="1"/>
    	      </g>
    	    </g>
    	  </g>
    	</svg>
    </button>`;
    var html = '<div class="lookbook-details zoom-parent" id="lookbook-details" body-scroll-lock-ignore>'+looks+'<a href="#" class="x-close" aria-label="Close"><span class="displace">Close</span></a>'+scroll_up+'</div>';

    $(".lookbook").after(html);
    S.scroll.lock();
    $(".lookbook-details .x-close").click(function(e) {
      e.preventDefault();
      window.history.back();
      S.scroll.unlock();
      $(".lookbook-details").remove();
      for (i = 0; i < S.scroll.sectionWatchers.length; ++i) {
          S.scroll.sectionWatchers[i].destroy();
      }
      S.scroll.sectionWatchers = [];
    })

    // set correct scroll position for active id
    setTimeout(function() {
      console.log("id: " + id);
      var active_detail_id = '#' + id + "-detail";
      var top = $(active_detail_id).position().top;
      $(".lookbook-details").scrollTop(top).addClass("inited");
      if ($(active_detail_id).index() >= 9) {
        $up.addClass("show");
      }
    }, 200)

    var $up = $(".scroll-up-looks");
    $up.click(function(e) {
      e.preventDefault();
      $(".lookbook-details").animate({
        scrollTop: 0
      }, 150)
    })


    // setup scroll-based active state
    var containerElement = document.getElementById("lookbook-details");
    var containerMonitor = scrollMonitor.createContainer(containerElement);
    S.scroll.sectionWatchers = [];
      var f = 0;

    $(".look-detail").each(function() {
      var $t = $(this);
      S.scroll.sectionWatchers[f] = containerMonitor.create($t, S.size.windowH*-0.5);

      if (S.scroll.sectionWatchers[f].isInViewport) {
        $(this.watchItem).siblings().removeClass("active");
        $(this.watchItem).addClass("active");
        var id = $(this.watchItem).attr("id");
          console.log("id2: " + id);
        if (id) {
          id = id.replace("-detail", "");
          history.pushState(null, id, '#'+id);
        }


      }
      S.scroll.sectionWatchers[f].enterViewport(function() {
        var id = $(this.watchItem).attr("id");

        if (id && this.isFullyInViewport == true) {
          $(this.watchItem).siblings().removeClass("active");
          $(this.watchItem).addClass("active");
          var id = $(this.watchItem).attr("id");
          console.log(this.isFullyInViewport);
          console.log("id3: " + id + " / this.isFullyInViewport: " + this.isFullyInViewport);
          id = id.replace("-detail", "");
          history.pushState(null, id, '#'+id);
          if ($(this.watchItem).index() == 9) {
            $up.addClass("show");
          } else if ($(this.watchItem).index() == 8) {
            $up.removeClass("show");
          }
        }


      });
      f++;
    })

    // zoom functionality
    S.zoom.init($(".lookbook-details"));
    /*
    $(".lookbook-details .zoom-btn").click(function(e) {
      e.preventDefault();
      S.lookbook.zoom($(this));
    }) */

    // load the rest
    $(".look-detail img.lazyload").each(function() {
      $(this).attr("src", $(this).attr("data-src"));
    })
  }

  /*

  S.lookbook.zoom = function($t) {
    var img = $t.siblings("img").attr("src");
    $t.parents(".look-detail").first().append('<div class="zoom-image lookbook-zoom"><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    if (S.isMobile) {
      $(".lookbook-zoom").animate({ scrollLeft: S.size.windowW }, 0);
    }
    $(".lookbook-zoom").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".lookbook-zoom").remove();
    });
  } */




  S.film = {}
  S.film.init = function() {
    $(".layout-page-film").each(function() {
      $(this).find(".link-overlay").click(function(e) {
        e.preventDefault();
        e.preventDefault();
        $(".film-container.full").removeClass("inactive");
        videojs('playerfilm').play();
        $(".film-container.preview").remove();
      })
    })
  }


  S.overview = {}


  /*

  S.overview.init = function() {
    $(".layout-page-overview").each(function() {
      $(this).find(".zoom-btn").click(function(e) {
        e.preventDefault();
        S.overview.zoom($(this));
      })
    })

  }

  S.overview.zoom = function($t) {
    var img = $t.attr("data-zoom-src");
    $t.parents(".module").first().append('<div class="zoom-image overview-zoom"><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    if (S.isMobile) {
      $(".overview-zoom").animate({ scrollLeft: S.size.windowW }, 0);
    }
    $(".overview-zoom").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".overview-zoom").remove();
    });
  } */


  S.zoom =  {}

  S.zoom.init = function($s) {
    $s.find(".zoom-btn").click(function(e) {
      e.preventDefault();
      S.zoom.show($(this));
    })
  }

  S.zoom.show = function($t) {
    var img = $t.siblings("img").attr("data-zoom-src");
    console.log("img: " + img);
    if (!img) {
      img = $t.attr("data-zoom-src");
    }
    var scrollLeft = 0, scrollTop = 0;

    if ($t.hasClass("pdp-zoom-btn")) {
      $(".product-info-wrapper").addClass("zoomed");
      $(".purchase-section-interior,.preorder").addClass("z-up");
      $(".shoppingBagDrawer-wrapper").addClass("z-up");
      scrollTop = S.size.windowH;
    }
    if (S.isMobile) {
      scrollLeft = S.size.windowW;
    }

    $t.parents(".zoom-parent").first().append('<div class="zoom-image" body-scroll-lock-ignore><img src="'+img+'" /><span class="x-close"><span class="displace">Close</span></span></div>');
    $(".zoom-image").addClass("inited").click(function(e) {
      e.preventDefault();
      $(".zoom-image").remove();
      bodyScrollLock.clearAllBodyScrollLocks();
      if ($(".product-info-wrapper.zoomed").length) {
        $(".product-info-wrapper").removeClass("zoomed");
        $(".purchase-section-interior,.preorder").removeClass("z-up");
        $(".shoppingBagDrawer-wrapper").removeClass("z-up");
      }
    });

    $(document).on('keyup.zoom_escape', function(e) {
     if (e.key === "Escape") {
        $(".zoom-image.inited").trigger("click");
        $(document).unbind('keyup.zoom_escape');
     }
    });

    $(".zoom-image img").imagesLoaded(function() {
      bodyScrollLock.disableBodyScroll($("#page-container"), {
         allowTouchMove: el => {
           while (el && el !== document.body) {
             if (el.getAttribute("body-scroll-lock-ignore") !== null) {
               return true
             }
             el = el.parentNode
           }
         }
       })
      $(".zoom-image").animate({ scrollLeft: scrollLeft, scrollTop: scrollTop }, 0).addClass("image-loaded");
    })

  }



  S.pdp = {}
  S.pdp.getVariantInput = function($t) {
    var attr = $t.attr("data-attr");
    var value = $t.attr("data-value");
    var $variants = $("#product-variants");
    var $variant = $variants.find("input["+attr+"='"+value+"']");
    return $variant;
  }

  S.pdp.zoom = function($t) {

  }

  S.pdp.init = function() {
    $(".product-wrapper .zoom-btn").click(function(e) {
      e.preventDefault();
      S.pdp.zoom($(this));
    })

    $(".purchase-section > .blocker").click(function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.active").trigger("click");
    })

    $(".option-values > .x-close").click(function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.size-selector.active").trigger("click");
    })

    $(".colors-drawer .x-close, .colors-drawer .blocker").click(function(e) {
      var $p = $(".purchase-section");
      $p.removeClass("active");
      $p.find("button.product-option-selector.color-selector.active").removeClass("active");
      S.scroll.unlock();
      setTimeout(function() {
        if (!$p.find("button.product-option-selector.active").length) {
          // check !!
          $p.removeClass("z-up");
        }
      }, 250)

    })

    $(".product-option-colors").click(function(e) {
      e.preventDefault();
      $(".purchase-section").find("button.product-option-selector.color-selector:not(.active)").trigger("click");
    })

    $("button.product-option-selector").each(function() {
      $(this).click(function(e) {
        if (!$(this).attr("data-custom-drawer")) {
          // everything else except color, currently this means size
          e.preventDefault();
          var $options = $(this).siblings(".option-values").first();
          var $selector = $(this).parents(".selector-wrapper").first();
          if ($(this).hasClass("active")) {
            $options.removeClass("active");
            $selector.removeClass("active");
            S.scroll.unlock();
          } else {
            $options.addClass("active");
            $selector.addClass("active");
            if (!S.isDesktop) {
              S.scroll.lock();
            }
          }
        }

        var $p = $(".purchase-section");
        // both color and size
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          if ($(this).attr("data-custom-drawer")) {
            var id = $(this).attr("data-custom-drawer");
            // custom drawer is open, so close that too
            if (id) {
              var $t = $("."+id);
              $t.find(".x-close").trigger("click");
            }
          }
        } else {
          if ($p.find("button.product-option-selector.active").length) {
            // others, so close those first
            $p.find("button.product-option-selector.active").trigger("click");
          }
          S.scroll.lock();
          $(this).addClass("active");
        }



        if (!$p.find("button.product-option-selector.active").length) {
          $p.removeClass("active");
          setTimeout(function() {
            // first let the drawer slide out
            if (!$p.find("button.product-option-selector.active").length) {
              // check again!!
              $p.removeClass("z-up");
            }
          }, 300)

        } else {
          $p.addClass("active z-up");
        }
      })
    })

    $(".product-option-size").each(function() {
      var $variant = S.pdp.getVariantInput($(this));
      if ($variant.attr("data-available") != "true") {
        $(this).addClass("sold-out");
      }

      $(this).click(function(e) {
        e.preventDefault();
        $(this).addClass("selected").siblings().removeClass("selected");
        var $variant = S.pdp.getVariantInput($(this));
        $variant.siblings().attr("checked", false);
        $variant.attr("checked", true);
        var $trigger = $(this).parents(".selector-wrapper").first().find(".product-option-selector").first();
        value = $(this).attr("data-value");

        var price = $variant.attr("data-price"), compare_price = $variant.attr("data-orig-price"), available = $variant.attr("data-available");
        $(".price-wrapper .compare-price").remove();
        $(".price-wrapper .price").html(price);
        if (compare_price != price && compare_price) {
          $(".price-wrapper").prepend('<span class="compare-price">'+compare_price+'</span>');
        }
        $trigger.text(value);
        setTimeout(function() {
          if ($trigger.hasClass("active")) {
            $trigger.trigger("click");
          }
        }, 100)
      })
    })


    $(".product-option-size.selected").trigger("click");

    S.scroll.pdpWatcher = scrollMonitor.create($(".pdp-breaker"));
    if (S.scroll.pdpWatcher.isInViewport) {
      $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").addClass("purchase-absolute");
    }
    S.scroll.pdpWatcher.exitViewport(function() {
      if (S.scroll.pdpWatcher.isBelowViewport) {
        $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").removeClass("purchase-absolute");
      }

    });
    S.scroll.pdpWatcher.enterViewport(function() {
      $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").addClass("purchase-absolute");
    });

  }




  S.promoBar = function() {
    if ($(".notification-bar").length) {
      var $bar = $(".notification-bar");
      var promocookie = Cookies.get('fog_promo_closed');
      if (promocookie) {
        $bar.remove();
        $(".with-promo-bar").removeClass("with-promo-bar with-white-bar");
      } else {
        var $header = $(".header");
        S.scroll.promoWatcher = scrollMonitor.create($bar);
        if (S.scroll.promoWatcher.isInViewport) {
          $(".without-promo-bar").addClass("with-promo-bar");
          $header.removeClass("header--scrolled header--actually-scrolled");
        }
        S.scroll.promoWatcher.exitViewport(function() {
          $(".with-promo-bar").addClass("without-promo-bar").removeClass("with-promo-bar");
          $header.addClass("header--scrolled header--actually-scrolled");
        });
        S.scroll.promoWatcher.enterViewport(function() {
          $(".without-promo-bar").addClass("with-promo-bar");
          $header.removeClass("header--scrolled header--actually-scrolled");
        });

        $bar.find(".x-sm-close").click(function(e) {
          e.preventDefault();
          $bar.remove();
          S.scroll.promoWatcher.destroy();
          $(".with-promo-bar").removeClass("with-promo-bar with-white-bar ");
          Cookies.set('fog_promo_closed', 'true'); // remember to not show again
        })
      }
    }
  }





  S.init = function() {
    // console.log("S.init... ");
    S.isTouchDevice = isTouchDevice();
    // console.log("S.isTouchDevice: " + S.isTouchDevice);

    S.scroll.action();
    $(window).bind("scroll", S.scroll.action);

    S.size.all();
    setTimeout(function() {
      S.size.all();
      $(window).resize(function() {
        S.resizeTimer && clearTimeout(S.resizeTimer);
        S.resizeTimer = setTimeout(S.size.all, 300);
      });
    }, 100);

    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
      }
    }


    S.promoBar();

    $(".scroll-up").click(function(e) {
      e.preventDefault();
      $("body,html").animate({
        scrollTop: 0
      }, 150)
    })


    $('body').on('click', '.image-viewer a.close', function(e) {
      closeViewer(e);
    });

    $('body').on('click', 'a.current.close', function(e) {
      e.preventDefault();
      closeViewer(e);
    });

    $('body').on('click', '.video-viewer a.close', function(e) {
      closeVideoViewer(e);
    });



    var ll = new LazyLoad({
        threshold: 0,
        callback_set: function(el) {
         frames = $('.lookbook-wrapper .look');
        }
    });

    $("[data-custom-drawer]").click(function(e) {
      e.preventDefault();
      var id = $(this).attr("data-custom-drawer");
      if (id) {
        var $t = $("."+id);
        if ($t.length) {
          if (!$t.hasClass("active")) {
            S.scroll.lock();
            $t.addClass("active");
          }
        }
      }
    })

    $(".drawer").each(function() {
      $(this).find(".x-close,.blocker").click(function(e) {
        e.preventDefault();
        var $p = $(this).parents(".drawer").first();
        $p.removeClass("active");
        S.scroll.unlock();
      })
    })

    $(".expandable-title").click(function(e) {
      e.preventDefault();
      var $t = $(this).parents(".expandable-text");
      if ($t.hasClass("active")) {
        $t.removeClass("active");
      } else {
        $t.siblings(".expandable-text.active").removeClass("active");
        $t.addClass("active");
      }
    })


    $('.share-enable:not(.expandable-title)').on('click', function(e) {
      e.preventDefault();
      $('.share--product').toggleClass('open');
    });

    var shareUrl = window.location.host + window.location.pathname;
    $('.share-list-item--fb').on('click', function(e) {
      var fbTitle;
      var fbProductTitle = $(this).data('title');
      fbTitle = 'The ' + fbProductTitle + ' from @fearofgod Sixth Collection ';
      window.open('http://www.facebook.com/sharer.php?u=' + 'https%3A%2F%2F' + shareUrl + '&t=' + fbTitle, 'facebookMessage', 'width=600, height=300');
      e.preventDefault();
    });

    $('.share-list-item--tw').on('click', function(e) {
      var twText;
      var twProductTitle = $(this).data('title');
      twText = 'The ' + twProductTitle + ' from @fearofgod Sixth Collection ';
      window.open('http://twitter.com/share/?text=' + twText + '&url=https://' + shareUrl, 'twitterMessage', 'width=600, height=300');
      e.preventDefault();
    });


    // nav hovers

    $(".header-interior").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".header").addClass("header--toggled");
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".header").removeClass("header--toggled header--subopen header--searchopen");
        $(".header .hovered").removeClass("hovered");
      }
    })

    $(".header .nav-item.top-level.has-secondary").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        var $h = $(".header");
        $h.addClass("header--subopen");
        $(this).addClass("hovered");
        $(this).siblings(".hovered").removeClass("hovered");
        if ($(this).hasClass("nav-search-item")) {
          $h.addClass("header--searchopen");
        }
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        var $t = $(this);
        setTimeout(function() {
          if (!$(".header.header--toggled").length) {
            $t.removeClass("hovered");
            $(".header").removeClass("header--subopen header--searchopen");
          }
        }, 200)
      }
    })

    // nav clicks for devices

    $(".shopify-section.header-section .secondary-nav .x-sm-close").click(function(e) {
      if (!S.isDesktop) {
        e.preventDefault();
        $(".header").removeClass("header--subopen header--searchopen");
        $(".header .nav-item.top-level.has-secondary.hovered").removeClass("hovered");
        $(".nav-main.device-only").find(".hovered").removeClass("hovered");
        S.scroll.unlock();
      }
    })

    $(".header button.blocker").click(function(e) {
      e.preventDefault();
      var $h = $(".header");
      if ($h.hasClass("header--searchopen")) {
        $h.removeClass("header--toggled");
      }
      $h.removeClass("header--subopen header--searchopen").find(".hovered").removeClass("hovered");
      $(".nav-main.device-only").find(".hovered").removeClass("hovered");
      if (S.isTouchDevice && S.isLandscape) {
        $h.removeClass("header--toggled");
      }

      S.scroll.unlock();

    })

    $(".shopify-section.header-section .nav-item.top-level.has-secondary .nav-item-link").click(function(e) {
      if (!S.isDesktop || S.isTouchDevice) {
        var $h = $(".header");
        var $p = $(this).parents(".nav-item").first();
        e.preventDefault();
        if (!$p.hasClass("hovered")) {
          $h.addClass("header--subopen");
          $p.addClass("hovered");
          $p.siblings(".hovered").removeClass("hovered");
          if (S.isTouchDevice && S.isLandscape) {
            $h.addClass("header--toggled");
          }
          if ($(this).hasClass("nav-search")) {
            $h.addClass("header--searchopen");
            $h.addClass("header--toggled");
          }
          S.scroll.lock();
        }

      }
    })

    /*
    $(".nav-main .nav-link.has-tertiary").click(function(e) {
      if (!S.isDesktop) {
        e.preventDefault();
        $(this).parents(".has-secondary").first().find(".has-tertiary.hovered").removeClass("hovered");
        $(this).addClass("hovered");
      }
    }) */

    KlaviyoSubscribe.attachToForms('#footer_newsletter', {
      hide_form_on_success: true,
      success_message: $("#footer_newsletter").attr("data-success-msg"),
      success: function ($form) {
     // `$form` is a jQuery wrapper around the form that was submitted. This makes it easy to get the email address or form fields.
       $form.addClass("submitted");
     }
    });

    S.list.pop();

    $('.image-carousel.hero-slick').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      fade: true,
      speed: 1500,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false
    });
    $('.image-carousel.landing-slick').slick({
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      speed: 1500,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnFocus: false,
      pauseOnHover: false
    });

    $(".collection-nav-wrapper").hoverIntent(function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".active-category-nav").addClass("active");
      }
    }, function() {
      if (S.isDesktop && !S.isTouchDevice) {
        $(".active-category-nav").removeClass("active");
      }
    })

    $(".active-category-nav").click(function(e) {
      if (!S.isDesktop || S.isTouchDevice) {
        e.preventDefault();
        var $c = $(".collection-header");
        if (!$(this).hasClass("active")) {
          $(this).addClass("active");
          $c.addClass("active category-nav-active");
          $(".nav-main").addClass("z-down");
          S.scroll.lock();
        } else {
          $(this).removeClass("active");
          $c.removeClass("active category-nav-active");
          $(".nav-main").removeClass("z-down");
          S.scroll.unlock();
        }
      }
    });

    $(".filters-toggle").click(function(e) {
      e.preventDefault();
      var $c = $(".collection-header"), $f = $(this).siblings(".filters-body").first(), $h = $(".header");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $c.removeClass("active filters-active");
        $f.removeClass("active");
        $h.removeClass("filters-open");
      } else {
        $(this).addClass("active");
        $f.addClass("active");
        $c.addClass("active filters-active");
        $h.addClass("filters-open");
      }
    })

    /*
    if ($(".filters-body").length) {
      S.scroll.filtersWatcher = scrollMonitor.create($(".filters-body"));
      S.scroll.filtersWatcher.exitViewport(function() {
        if ($(this.watchItem).hasClass("active")) {

        }
        if (S.scroll.filtersWatcher.isBelowViewport) {
          $(".purchase-section-interior, .preorder, .scroll-up, .nav-main").removeClass("purchase-absolute");
        }

      });

    }
    */

    S.zoom.init($(".page-container"));
    S.lookbook.init();
    // S.overview.init();
    S.film.init();
    S.pdp.init();

    setTimeout(function() {
      $("body").addClass("init");
    }, 500)


    initZoom();
    revealModal();


  }

  S.init();

});

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

function closeViewer(e) {
  e.preventDefault();
  $.scrollLock( false );
  frameIndex = 0;
  $('body').removeClass('frame-open no-scroll');
  $('.image-viewer').removeClass('visible');
  setTimeout(function() {
    $('.image-viewer').remove();
  }, 500);
}

function openViewer(e) {
  e.preventDefault();
  $.scrollLock( true );
  var frameSrc = frames[frameIndex].dataset.attrFullsize;
  $('body').append('<div class="image-viewer"><a class="close" href="#">CLOSE</a><div class="lookbook-style-images"><div class="frame-container grid justify-center align-center"><div class="frame-wrapper frame"><div class="frameNav prevFrame"></div><div class="frameNav nextFrame"></div><div class="photo grid justify-center align-center"><img class="img-stilframe" src="' + frameSrc + '" /></div></div></div></div></div>');

  $('.image-viewer').imagesLoaded(function() {
    $('body').addClass('frame-open no-scroll');
    $('.image-viewer').addClass('visible');

    var trailerVid = $('#trailer-video')[0];
    if ($('#trailer-video').parents('.video-wrap').find('.audio-control').hasClass('on')) {
      trailerVid.muted = true;
      $('#trailer-video').parents('.video-wrap').find('.audio-control').removeClass('on');
    }

    $('.frameNav.prevFrame').on('click', function(e) {
      minusFrame(frameIndex);
    });

    $('.frameNav.nextFrame').on('click', function(e) {
      plusFrame(frameIndex);
    });

  });
}

function revealModal() {

  $('.reveal[data-reveal]').on('click', function(e) {

    e.preventDefault();
    $.scrollLock( true );
    $('body').toggleClass('frame-open no-scroll');

    var revealBox = $(this).attr('data-reveal');
    $(revealBox).toggleClass('open');

  });

  $('.reveal-modal').on('click', function(e) {

    e.preventDefault();
    $.scrollLock( false );
    $('body').removeClass('frame-open no-scroll');

    $('.reveal-modal').removeClass('open');

  });
}

function closeVideoViewer() {
  $('body').removeClass('video-open no-scroll');
//   $('#viewer-video video').get(0).pause();
}

$(document).on('keydown', function(e) {
  if(e.keyCode == 39 || e.keyCode == 40) {
    plusFrame(frameIndex);
  }
  if(e.keyCode == 37 || e.keyCode == 38) {
    minusFrame(frameIndex);
  }
});

function plusFrame(n) {
  if((n+1) < frames.length) {
    frameIndex = n+1;
    showFrame(frameIndex);
  } else {

  }
}

function minusFrame(n) {
  if(n > 0) {
    frameIndex = n - 1;
    showFrame(frameIndex);
  }
}

function currentFrame(n) {
  showFrame(frameIndex = n);
}

function showFrame(n) {
  $('.photo .img-stilframe').attr('src', frames[n].dataset.attrFullsize);
}


$(document).on('keydown', function(e) {
  if(e.keyCode == 27) {
    if($('body.frame-open').length) {
      closeViewer(e);
    }
//     closeVideoViewer(e);
  }
});

var initZoom = function() {
  //if( !isTouchDevice() ) {
  if (isTouchDevice()) {
    $('body').addClass('is-touch-device');
  } else {
    $('body').addClass('not-touch-device');
  }

  $('.look[data-attr-fullsize]').on('click', function(e) {
    frameIndex = $('.lookbook-wrapper .look').index(this);
    openViewer(e);
  });

  $('[data-video]').on('click', function(e) {
    e.preventDefault();

    if (isTouchDevice()) {
      window.location.href = $(this).attr('data-video');
    } else {

      setTimeout(function() {
        $('#viewer-video video').get(0).play();
      }, 300);

      setTimeout(function() {
        $('body').addClass('video-open no-scroll');
        $('#viewer-video video')[0].onended = function() {
          closeVideoViewer();
        };
      }, 400);
    }

  });

  $('body').on('click', '.video-viewer', function(e) {
    // e.preventDefault();
    // closeVideoViewer();
  });

  $('body').on('click', '.attr-link a', function(e) {
    e.stopPropagation();
  });

  $('body').on('touchstart click', '.mobile-attr a', function(e) {
    e.stopPropagation();
    window.location.href = $(this).attr('href');
  });

}

$('video').each(function(){
    if ($(this).is(":in-viewport")) {
        $(this)[0].play();
      	$(this)[0].muted = false;
    } else {
        $(this)[0].pause();
    }
});
